import EditPageForm from '@/components/refinedev/pages/edit-form';
import DepartmentForm from './department-form';
import { SaveButton } from '@/components/refinedev/action_buttons';
import StaffInDepartmentManager from './staffs-in-department-manager';
import { useResourceParams } from '@refinedev/core';

const DepartmentEdit = () => {
  const {id} = useResourceParams();
  return (
    <>
    <EditPageForm transformBeforeSave={DepartmentForm.transformBeforeSave}>
      <DepartmentForm />
      <SaveButton className="mt-2" />
    </EditPageForm>
    {id && <StaffInDepartmentManager department_id={id}/>}
    </>
  );
};

export default DepartmentEdit;
